export default __webpack_public_path__ + "img/rank3l-acfbbfd9.png";